export default {"src":"/_next/static/media/pace.a26b02d7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};